import SecureLS from "secure-ls";

/**
 * Storage Keys.
 */
export const storgeKeys = {
  // 使用者記住帳密
  userRemember: "hylProperty.userRemember",
  // 使用者登入憑證
  userCredential: "hylProperty.userCredential",
  // 物品列表查詢條件（從 header 導頁至物品列表時使用）
  delegatePackageCondition: "delegatePackage.condition"
};

/**
 * Secure LocalStorage.
 * @description https://varunmalhotra.xyz/secure-ls/
 */
export const secureStroge = new SecureLS({
  encodingType: "des",
  isCompression: false,
  encryptionSecret: "i-love-hyl"
});
